module.exports = __webpack_public_path__ + "img/05—Applications—Speed Test 00 > Initial State.a6cdffce.jpg";